import { buildUpgradeRecommendationRequestBody } from '@wix/package-picker-sdk';
import { useCurrentModule } from '../components';
import { useUpgradeRecommendationEnabled } from './useUpgradeRecommendationEnabled';
import { isTimeoutError, RECOMMENDATION_QUERY_OPTIONS } from './recommendationQuery';
import { useReportQueryError } from './useReportQueryError';
const EMPTY_BODY = {
  subscriptionId: '',
  currentProductFamilyId: ''
};
export const upgradeStateOf = data => {
  if (!data) {
    return undefined;
  }
  if (data.plan.recommendedProductFamilyId) {
    return 'move';
  }
  return data.plan.suppressCatalogHighlight ? 'stay' : 'default';
};
const toResponse = result => result ? {
  plan: result.plan,
  cycles: result.cycles,
  siteName: result.siteName
} : undefined;
export const useUpgradeRecommendation = () => {
  var _offering$discountInf;
  const module = useCurrentModule();
  const {
    isEligible,
    shouldFetch,
    isShadow,
    variant,
    entry,
    ineligibleReasons,
    isLoading: isEligibilityLoading
  } = useUpgradeRecommendationEnabled();
  const {
    data: offering,
    isLoading: isOfferingLoading
  } = module.SDK.eclipseOfferingApiClient.hooks.useFetchOffering({});
  const body = buildUpgradeRecommendationRequestBody({
    currentSubscription: offering == null ? void 0 : offering.currentSubscriptionInfo,
    saleType: offering == null || (_offering$discountInf = offering.discountInfo) == null || (_offering$discountInf = _offering$discountInf.sale) == null ? void 0 : _offering$discountInf.saleType
  });
  const reportQueryError = useReportQueryError();
  const {
    data,
    isLoading,
    isError,
    error
  } = module.SDK.upgradeRecommendationApiClient.hooks.useGetUpgradeRecommendation(body ?? EMPTY_BODY, shouldFetch && Boolean(body), {
    ...RECOMMENDATION_QUERY_OPTIONS,
    onError: queryError => reportQueryError('getUpgradeRecommendation', queryError)
  });
  const isVariantB = variant === 'B';
  const isServingLoading = isEligibilityLoading || isVariantB && (isOfferingLoading || Boolean(body) && isLoading);
  const response = isVariantB ? toResponse(data) : undefined;
  return {
    data: response,
    shadowData: isShadow ? toResponse(data) : undefined,
    requestId: data == null ? void 0 : data.requestId,
    isApplied: isVariantB && Boolean(data),
    isEligible,
    isShadow,
    variant,
    entry,
    ineligibleReasons,
    isLoading: isServingLoading,
    isFallback: isVariantB && isEligible && !isServingLoading && upgradeStateOf(response) === 'default',
    isShadowPending: isShadow && (isOfferingLoading || Boolean(body) && isLoading),
    isError,
    isTimeout: isError && isTimeoutError(error)
  };
};
//# sourceMappingURL=useUpgradeRecommendation.js.map